import React, {useEffect, useMemo, useState} from 'react'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.min.css'
import '@uppy/webcam/dist/style.min.css'

import classNames from "classnames";

import Uppy from '@uppy/core'
import {DashboardModal} from '@uppy/react'
import Webcam from '@uppy/webcam'

import {FilePond, File, registerPlugin} from 'react-filepond'
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import FilePondPluginImageEdit from 'filepond-plugin-image-edit'

const ALLOWED_FILE_TYPES = ["image/gif", "image/jpeg", "image/png"]
const uppy = new Uppy()

const UppyModalUploader = ({buttonLabel, formMode, methods}) => {
  const {clearErrors, setValue} = methods
  const [open, setOpen] = useState(false)
  const [selectedFileName, setSelectedFileName] = useState()

  const uppy = useMemo(() => {
    return new Uppy({
      restrictions: {
        maxFileSize: 3000000,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ALLOWED_FILE_TYPES
      },
      onBeforeFileAdded: (file) => {
        console.log(file)
        if (file.handledByDoka) {
          setOpen(false)
          clearErrors(`${formMode}_images`)
          setValue(`${formMode}_images`, {"0": file.data})
          return true;
        }

        doka.edit(file.data).then(output => { // add the Doka edit result back to Uppy
          setSelectedFileName(file?.data?.name)
          setOpen(false)
          clearErrors(`${formMode}_images`)
          setValue(`${formMode}_images`, {"0": output.file})

          // uppy.addFile(Object.assign({}, file, {
          //   data: output.file,
          //   handledByDoka: true
          // }));
        });

        setOpen(false)
        clearErrors(`${formMode}_images`)
        setValue(`${formMode}_images`, {"0": file.data})
        return false;
      },
    })
    .use(Webcam, {
      countdown: false,
      mirror: false,
      showRecordingLength: false,
      preferredVideoMimeType: null,
      preferredImageMimeType: null,
      modes: [
        //'video-audio',
        //'video-only',
        //'audio-only',
        'picture'
      ],
      videoConstraints: {
        facingMode: 'environment', // 'user'
        showVideoSourceDropdown: true,
        width: { min: 720, ideal: 1280, max: 1920 },
        height: { min: 480, ideal: 800, max: 1080 },
      },
      locale: {},
    }) // `id` is… "MyWebcam"
  }, [])

  const doka = useMemo(() => {
    return new Doka.create({
      utils: ['crop'], // , 'filter', 'color'
    })
  }, [])

  useEffect(() => {
    uppy.on('file-removed', (file, reason) => {
      clearErrors(`${formMode}_images`)
      setValue(`${formMode}_images`, {})
    })
    return () => uppy.close()
  }, [])

  const handleOnButtonClick = () => {
    uppy.reset()
    setValue(`${formMode}_images`, {})
    setOpen(true)
  }

  return <>
    <button
      type={"button"}
      className="btn btn-light btn-block"
      id="uppy-modal-btn"
      onClick={handleOnButtonClick}
    >
      {buttonLabel}
    </button>

    {selectedFileName && <small className={"uppy-file-name"}>
      {selectedFileName}
    </small>}
    <DashboardModal
      uppy={uppy}
      open={open}
      closeModalOnClickOutside
      onRequestClose={setOpen}
      hideUploadButton={true}
      plugins={['Webcam']}
    />
  </>
}


const TagOwnerImageFormField = ({
                                  register,
                                  field,
                                  formMode,
                                  labelText,
                                  labelWidth,
                                  inputWidth,
                                  fieldType,
                                  filedValues,
                                  error,
                                  methods
                                }) => {
  // instead of methods could use https://stackoverflow.com/a/68623501/1990276
  // But i don't want to break anything.
  const {clearErrors, setValue} = methods
  const [customFileInputLabel, setCustomFileInputLabel] = useState(labelText)
  const [selectedFileName, setSelectedFileName] = useState()

  let customFileInputDefaultLabel = labelText
  filedValues.split("\n").forEach(row => {
    const rowSplit = row.split("@@@")
    const key = rowSplit[0]
    const value = rowSplit[1]

    if (key === "custom-file-input-default-label") {
      customFileInputDefaultLabel = value
    }
  })

  useEffect(() => {
    setCustomFileInputLabel(customFileInputDefaultLabel)
  }, [])

  let inputContent = <div className="custom-file">
    <input
      {...register(`${formMode}_images`, {
        onChange: (e) => {
          if (e.target?.files && e.target.files[0].name) {
            setSelectedFileName(e.target.files[0].name)
          } else {
            setSelectedFileName("")
          }

          clearErrors(`${formMode}_images`)
        }
      })}
      type="file"
      accept={ALLOWED_FILE_TYPES.join(", ")}
      className={classNames("custom-file-input form-control-sm", {"is-invalid": error})}
      id={`${formMode}_images`}
    />
    <label
      className={classNames("custom-file-label col-form-label-sm", {"is-invalid": error})}
      htmlFor={`${formMode}_images`}
    >
      {selectedFileName || customFileInputLabel}
    </label>
    {error}
  </div>

  if (fieldType === "tag_owner_image_uppy") {
    let buttonLabel = "Click to select a file."

    if (filedValues) {
      filedValues.split("\n").forEach(row => {
        const rowSplit = row.split("@@@")
        const key = rowSplit[0]
        const value = rowSplit[1]

        if (key === "button-label") {
          buttonLabel = value
        }
      })
    }

    inputContent = <>
      <div className={classNames("", {"is-invalid": error})}>
        <UppyModalUploader
          buttonLabel={buttonLabel}
          formMode={formMode}
          methods={methods}
        />
      </div>
      {error}
    </>
  }


  return <div className="form-group row" id={"form-group-" + field} key={"col" + field}>
    <label htmlFor={`${formMode}_images`} id={field}
           className={`col-md-${labelWidth} r-label col-form-label`}>
      {labelText}
    </label>
    <div className={`col-md-${inputWidth}`}>
      {inputContent}
    </div>
  </div>
}

export default TagOwnerImageFormField